import {Table} from 'antd';
import cn from 'classnames';
import {omit} from 'lodash-es';
import React, {useState, ReactElement} from 'react';

import {SimpleActionButton} from 'components/form/components';
import {ITableReportColumnProps} from 'components/table-report/table-report-columns/table-report-columns';
import '../../table-row-drillup-content.less';
import {TEntity} from 'modules/data';
import {TDrillUpParentDocument} from 'store/slices/table-report-slice/table-report-slice-types';

import {RowChildrenContainer} from '../row-children-container/row-children-container';

interface ISourceRowProps {
    field: TEntity & {children: TDrillUpParentDocument[]};
    sourceRowColumns: ReactElement;
    columnProps: ITableReportColumnProps;
}

export const SourceRow = ({
    field,
    sourceRowColumns,
    columnProps,
}: ISourceRowProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(true);
    const [isRowLoading, setIsRowLoading] = useState<boolean>(false);

    return (
        <>
            <div
                className={cn(
                    'drillup-grid-container', {
                        'with-margin-bottom': !isOpen,
                    },
                )}
            >
                <div className={cn('list__items')}>
                    { !!field?.children?.length && (
                        <div className="collapse-button-container">
                            <SimpleActionButton
                                type="link"
                                onClick={() => setIsOpen(!isOpen)}
                                className={cn('collapse-action-btn', 'collapse-action-btn--source')}
                                icon={isOpen ? 'MinusCircleOutlined' : 'PlusCircleOutlined'}
                            />
                            {isOpen && <div className={cn('row-vertical-line')} />}
                        </div>
                    )}
                    <div className={cn('row-container')}>
                        <h2>Исходная строка</h2>
                        <Table
                            dataSource={[omit(field, 'children')]}
                            pagination={{hideOnSinglePage: true}}
                            className="table-report__table"
                        >{sourceRowColumns}
                        </Table>
                    </div>
                </div>

                <RowChildrenContainer
                    isOpen={isOpen}
                    fieldChildren={field?.children ?? []}
                    columnProps={columnProps}
                    isRowLoading={isRowLoading}
                    setIsRowLoading={setIsRowLoading}
                    isFirstLevel
                />
            </div>
        </>

    );
};
